// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw在线终极版',
  fileSizeLimitTitle: '免费帐户的文件大小不能超过20MB。',
  freeTimesLimitTitle: '免费帐户的试用今天已用完。',
  freeImgCutoutTimesLimitTitle:
    '去除背景功能今日试用机会已用完，升级至Pro以访问所有高级功能',
  total: '全部的',
  enterCode: '输入码',
  signUpToPurchaseBtn: '注册并去购买',
  goPurchseBtn: '去购买',
  saveTips: '最多可节省{{num}}%',
  discount: '折扣',
  priceWeek: '$9.99',
  priceMonth: '$7.49',
  priceYear: '$3.75',
  billedMonth: '每月收费 29.99 美元',
  billedYear: '每年收费179.99 美元',
  week: '周',
  weekly: '每周',
  monthly: '每月',
  yearly: '每年的',
  AlreadySubscribe: '已经订阅？',
  vipTips1: '没有文件大小限制',
  vipTips2: '处理文件数量无限制',
  vipTips3: '无限制地更改图像背景',
  vipTips4: '使用所有免费工具和高级功能',
  purchaseTips: '自动续订并随时取消。',
  tips: '提示：',
  promoCodeInvalidTips: '你的优惠码无效',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
